module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('h1', {
    staticClass: "Heading-1",
    attrs: {
      "id": "_idParaDest-9"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor009"
    }
  }), _vm._v("Broken Embraces")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("You almost shudder when you recall it,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Exquisitely round, darker than blood-red,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("A mark such as a master would only")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Attempt after years of practicing colors")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("To portray in "), _c('span', {
    staticClass: "grame"
  }, [_vm._v("oils")]), _vm._v(" the skin of women,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("At once perfect and yet utterly real,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Such that neither man nor woman could bear")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("To look on it, knowing it must shrink and fade,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Even as they praise the artist and curse him, too,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("For anguish that will never go away")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("But live as long as the portrait remains,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Even thousands of years, should history")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Toy so with human overreaching.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("Every time you kissed her, you tasted it,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Almost afraid it would vanish, did you not,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("But it was always there the next time, tempting,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Until you realized not disappearance")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("But invitation was what troubled you,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("As if it challenged you to admit desire")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Is always desire not for what you think")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("But for what you hide from yourself, and her,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("The possibility of pure selfishness,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Never answering for the least abuse—")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("‘A cup of tea does from time to time spill.’")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("But neither of you enjoyed pettiness,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("And you each disdained adolescent pique.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("You remembered the journey you were on,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Though the mark grew only more beautiful.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("Bound in love’s thralldom, animals unfree,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Low feral moans, sometimes loud, breathless cries,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Reminded you that division is primal:")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Separate, beasts mate, individuals,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("As likely to maim or kill one another")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("As to breed successive generations—")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Estrus alone accounts for the boundary")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("That differentiates sex from slaughter …")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("And in many species fathers eat the young.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Like a wound sustained in mortal battle")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("The mark you kissed and tasted aroused fear")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("And savagery as well as tenderness,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("And this in her more than you (no surprise)")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Since she bore your frame and could’ve killed you.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("Brutality without end sorts our lot")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("With the fate of creatures who flame in flesh")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("That can’t otherwise survive in our planet’s space—")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Metabolism")]), _vm._v(" means "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("violent")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("change")]), _vm._v(",")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Constant explosions in our inmost cells,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Where mitochondrial fires burn till we die.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("If we don’t burn, we don’t live, oxygen")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Fueling hydro-carbons’ entropy.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Remember how hot to your touch her breasts")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("When you aroused her to her readiness?")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Mammals lay their eggs not in nests of straw")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Sticks, plastic, and leaves, but in uterine folds")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Where placenta and umbilicus protect")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Both creatures (two "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("in")]), _vm._v(" one, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("not")]), _vm._v(" two "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("as")]), _vm._v(" one),")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Providing necessary interruption")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Between immune systems by nature at war.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("Life is the dividend of separation.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("When she departed, inconsolably")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("You wept, but for yourself, of course, admit it.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Does anyone know what another feels?")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("For whom did you weep? Do you know? Can you say?")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("All feeling is empathy by inference")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("(As, in coupling, I can feel that she feels")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("But what she feels I have at best a clue")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("I guess from my body, which is not like hers),")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("And the room for error may as well stretch")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("As wide as the gap between me and you.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("Not that you didn’t love her: you loved her")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Very much, and she you. But we all know")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("‘Love’ is yet another four-letter word,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Though we resent having to confess it;")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("And many are the times we treat it as such,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Despite our self-loathing. Or, could it be")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Because of it? Of our need to convince")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Ourselves, if not others, we are moral agents")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Who know we ought to know better … do we?")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("No, you loved her and she acknowledged that,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Wanting to console you the best she could,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Such consolation as the dying may give,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Entering the ignorance from which none")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Has ever told a credible story—")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Only the living, even when they’re dead,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Tell stories we are willing to believe.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("For death to us is total separation,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Darker even than the mole you craved so much.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("See how we lavish our wealth on pretending")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("That this is not so, whether pyramids")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Or space stations are the vehicles of choice")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("To cross over "), _c('span', {
    staticClass: "grame"
  }, [_vm._v("borders")]), _vm._v(" we can’t even name.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("And how many secretly, guiltily,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Flirt with séances they outwardly scorn?")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("You’re certain, yes, you wouldn’t sell your soul?")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("‘Rot,’ you snarl. But what if tested? What then?")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("You’re likely right, yes—rot. But what do you feel?")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("We can’t endure finality, though we dwell")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("In finitude every day we are alive,")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Alone in bodies that can only touch")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("Overcoming broken embraces.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ef0a838","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781645367314_EPUB-9.vue
// module id = 84
// module chunks = 0